module.exports = __webpack_public_path__ + "img/DK28487150.e854a93c.png";